import React from 'react';
import { siteData } from '../data';

export default function Footer() {
  return (
    <footer className="relative bg-blue-900 text-white py-20 rounded-none overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/c548860d-721f-4acc-aa05-d4a436cb5ed1.jpg" 
          alt="" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-blue-900/90 mix-blend-multiply"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-8 mb-16 text-center md:text-left">
          <div className="md:col-span-2 lg:pr-12">
            <span className="text-3xl font-bold tracking-tight mb-6 block">
              {siteData.name.split('service')[0]}
              <span className="text-blue-200">service</span>
            </span>
            <p className="text-blue-100 text-lg max-w-md mx-auto md:mx-0">
              Din lokale ekspert i vinduespudsning. Vi leverer kvalitet og pålidelighed til hver eneste opgave.
            </p>
          </div>
          
          <div className="flex flex-col items-center md:items-start md:pt-2 lg:pt-0">
            <h4 className="text-xl font-bold mb-6">Kontakt</h4>
            <ul className="space-y-4 text-blue-100">
              <li>{siteData.contact.phone}</li>
              <li>{siteData.contact.address}</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-blue-200 text-sm text-center md:text-left">
          <p>© {new Date().getFullYear()} {siteData.name}. Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
}
